import React from 'react';
import Hero from '../components/sections/Hero';
import FeaturedServices from '../components/sections/FeaturedServices';

const Home = () => {
  return (
    <>
      <Hero />
      <FeaturedServices />
    </>
  );
};

export default Home; 